module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/final-reports/final-report-menu/final-report-menu/final-report-menu.component.html
// module id = ./src/app/final-reports/final-report-menu/final-report-menu/final-report-menu.component.html
// module chunks = main